import { render, staticRenderFns } from "./NewInscription.vue?vue&type=template&id=c62f8c34&scoped=true"
import script from "./NewInscription.vue?vue&type=script&lang=js"
export * from "./NewInscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62f8c34",
  null
  
)

export default component.exports